import React from 'react';
import cx from 'clsx';
import { product as productLabels } from '../../mockdata';
import Container from '../Container/Container';
import Title from '../Title/Title';
import Text from '../Text/Text';
import Anchor from '../Anchor/Anchor';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import classes from './IndexWrapper.module.scss';

interface IndexWrapperProps extends Omit<React.HTMLProps<HTMLDivElement>, 'size'> {
  className?: string;
  locale: string;
  labels: typeof productLabels;
  hide_language_selector?: boolean;
  hide_back_link?: boolean;
  backLink?: { href: string; children: string };
  disableNotePadding?: boolean;
  localeCountry?: string;
}

export default function IndexWrapper({
  className,
  locale,
  name,
  hide_language_selector,
  hide_back_link,
  backLink,
  labels,
  children,
  disableNotePadding,
  localeCountry,
  ...others
}: IndexWrapperProps) {
  return (
    <Container className={cx(classes.container, className)} {...others}>
      {!hide_back_link && <Anchor {...backLink} className={classes.backLink} />}
      <Title order={1} className={classes.title}>
        {name}
      </Title>
      {!hide_language_selector && (
        <LanguageSelector
          className={classes.language}
          locale={locale}
          localeCountry={localeCountry}
        />
      )}
      {children}
      <Text<HTMLDivElement>
        component="div"
        className={cx(classes.note, {
          [classes.noPadding]: disableNotePadding,
        })}
        dangerouslySetInnerHTML={{ __html: labels.notes }}
      />
    </Container>
  );
}
